export default __webpack_public_path__ + "static/media/cong.7d2b05d9.png";